import { ReactNode } from 'react'
import { Navigate } from 'react-router'
import { usePollsRef } from '@/api/pollsRef'

/**
 * Guard для роутов `/polls*`. Если юзер не в `POLLS_WHITELIST_USERS` (env на бэке,
 * читается через `/me/polls-ref.isPollsWhitelisted`) — редирект на `/dashboard`.
 * После Phase 3 (rollout всем) — этот guard можно убрать.
 *
 * ВАЖНО: этот компонент — **только UI-гард**. Все fetch'и к `/api/max/polls/*`
 * ДОПОЛНИТЕЛЬНО гейтятся внутри тела React Query hooks через `enabled: allowed && ...`
 * (правило §7.5 #1). Guard может подтвердить `allowed=true`, но пока `user` не долетел
 * — fetch тихо ждёт; иначе при frontend-first деплое 404 может уронить весь LK.
 *
 * Wait-state: пока `/me/polls-ref` ещё грузится (isLoading) — рендерим пусто, НЕ
 * редиректим на `/dashboard`. Иначе после hard-reload от magic-login юзера
 * выкинет с онбординга ещё до подтверждения whitelist'а.
 */
export function RequirePollsAccess({ children }: { children: ReactNode }) {
  const { data, isLoading } = usePollsRef()
  if (isLoading) return null
  if (data?.isPollsWhitelisted !== true) {
    return <Navigate to="/dashboard" replace />
  }
  return <>{children}</>
}
